import { render, staticRenderFns } from "./ClientReservationInfo.vue?vue&type=template&id=2d90ffae&scoped=true&"
import script from "./ClientReservationInfo.vue?vue&type=script&lang=js&"
export * from "./ClientReservationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90ffae",
  null
  
)

export default component.exports